(function () {
  /* ── Modal element references (re-queried after cart re-render) ── */
  function getModal() { return document.getElementById('CartUpsellModal'); }

  let currentProduct = null;
  let selectedVariant = null;

  function openModal() {
    const modal = getModal();
    if (!modal) return;
    modal.setAttribute('aria-hidden', 'false');
    modal.classList.add('active');
    document.body.classList.add('overflow-hidden-upsell');
  }

  function closeModal() {
    const modal = getModal();
    if (!modal) return;
    modal.setAttribute('aria-hidden', 'true');
    modal.classList.remove('active');
    document.body.classList.remove('overflow-hidden-upsell');
    currentProduct = null;
    selectedVariant = null;
  }

  function formatMoney(cents) {
    return (cents / 100).toLocaleString(undefined, {
      style: 'currency',
      currency: window.Shopify.currency.active,
    });
  }

  function renderOptions(product) {
    const optionsEl = getModal().querySelector('.cart-upsell-modal__options');
    optionsEl.innerHTML = '';

    product.options.forEach((option, optIndex) => {
      /* Shopify product.js returns options as objects: { name, position, values } */
      const optionName = typeof option === 'object' ? option.name : option;
      const optionValues = typeof option === 'object'
        ? option.values
        : (function () {
            const vals = [];
            product.variants.forEach(function (v) {
              var val = v.options[optIndex];
              if (vals.indexOf(val) === -1) vals.push(val);
            });
            return vals;
          })();

      const group = document.createElement('div');
      group.className = 'cart-upsell-modal__option-group';

      const label = document.createElement('p');
      label.className = 'cart-upsell-modal__option-label';
      label.textContent = optionName;
      group.appendChild(label);

      const btnWrap = document.createElement('div');
      btnWrap.className = 'cart-upsell-modal__option-values';

      optionValues.forEach(function (val, i) {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'cart-upsell-modal__option-btn';
        btn.textContent = val;
        btn.dataset.optionIndex = optIndex;
        btn.dataset.value = val;
        if (i === 0) btn.classList.add('selected');
        btn.addEventListener('click', function () { onOptionSelect(btn); });
        btnWrap.appendChild(btn);
      });

      group.appendChild(btnWrap);
      optionsEl.appendChild(group);
    });

    updateSelectedVariant(product);
  }

  function onOptionSelect(btn) {
    var siblings = btn.parentElement.querySelectorAll('.cart-upsell-modal__option-btn');
    siblings.forEach(function (s) { s.classList.remove('selected'); });
    btn.classList.add('selected');
    updateSelectedVariant(currentProduct);
  }

  function getSelectedOptions() {
    const modal = getModal();
    if (!modal) return [];
    const groups = modal.querySelectorAll('.cart-upsell-modal__option-values');
    const selected = [];
    groups.forEach(function (group) {
      const activeBtn = group.querySelector('.selected');
      if (activeBtn) selected.push(activeBtn.dataset.value);
    });
    return selected;
  }

  function updateSelectedVariant(product) {
    const modal = getModal();
    if (!modal) return;
    const addBtn = modal.querySelector('.cart-upsell-modal__add');
    const priceEl = modal.querySelector('.cart-upsell-modal__price');
    const imageEl = modal.querySelector('.cart-upsell-modal__image');

    const selected = getSelectedOptions();
    selectedVariant = product.variants.find(function (v) {
      return v.options.every(function (opt, i) { return opt === selected[i]; });
    });

    if (selectedVariant && selectedVariant.available) {
      addBtn.disabled = false;
      priceEl.innerHTML = formatMoney(selectedVariant.price);
      if (selectedVariant.compare_at_price && selectedVariant.compare_at_price > selectedVariant.price) {
        priceEl.innerHTML =
          '<span class="cart-upsell__price--sale">' + formatMoney(selectedVariant.price) + '</span>' +
          ' <s class="cart-upsell__price--compare">' + formatMoney(selectedVariant.compare_at_price) + '</s>';
      }
    } else {
      addBtn.disabled = true;
      const isNl = document.documentElement.lang === 'nl';
      priceEl.textContent = isNl ? 'Niet beschikbaar' : 'Unavailable';
    }

    if (selectedVariant && selectedVariant.featured_image) {
      imageEl.innerHTML = '<img src="' + selectedVariant.featured_image.src.replace(/(\.[^.]+)$/, '_240x$1') + '" alt="" width="120" height="120" />';
    }
  }

  /* ── Cart add & refresh ── */
  function addToCart(variantId) {
    var formData = { items: [{ id: variantId, quantity: 1 }] };

    return fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(formData),
    })
      .then(function (r) { return r.json(); })
      .then(function () { return refreshCartDrawer(); });
  }

  function refreshCartDrawer() {
    const cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer) {
      window.location.reload();
      return;
    }

    const sections = cartDrawer.getSectionsToRender().map(function (s) { return s.id; });

    return fetch(window.location.pathname + '?sections=' + sections.join(','))
      .then(function (r) { return r.json(); })
      .then(function (response) {
        cartDrawer.getSectionsToRender().forEach(function (section) {
          const el = section.selector
            ? document.querySelector(section.selector)
            : document.getElementById(section.id);
          if (el && response[section.id]) {
            el.innerHTML = new DOMParser()
              .parseFromString(response[section.id], 'text/html')
              .querySelector(section.selector || '.shopify-section').innerHTML;
          }
        });

        /* Re-bind everything after the DOM has been replaced */
        bindUpsellButtons();
        bindModalEvents();
      });
  }

  /* ── Button handlers ── */
  function handleDirectAdd(btn) {
    const variantId = btn.dataset.variantId;
    btn.classList.add('loading');
    btn.disabled = true;
    addToCart(variantId).finally(function () {
      btn.classList.remove('loading');
      btn.disabled = false;
    });
  }

  function handleVariantAdd(btn) {
    const handle = btn.dataset.productHandle;
    btn.classList.add('loading');

    fetch(window.Shopify.routes.root + 'products/' + handle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (product) {
        currentProduct = product;

        const modal = getModal();
        if (!modal) return;

        modal.querySelector('.cart-upsell-modal__title').textContent = product.title;

        if (product.featured_image) {
          modal.querySelector('.cart-upsell-modal__image').innerHTML =
            '<img src="' + product.featured_image.replace(/(\.[^.]+)$/, '_240x$1') + '" alt="" width="120" height="120" />';
        }

        renderOptions(product);
        openModal();
      })
      .finally(function () {
        btn.classList.remove('loading');
      });
  }

  /* ── Bind modal close/overlay/add events (called after each re-render) ── */
  function bindModalEvents() {
    const modal = getModal();
    if (!modal) return;

    const overlay = modal.querySelector('.cart-upsell-modal__overlay');
    const closeBtn = modal.querySelector('.cart-upsell-modal__close');
    const addBtn = modal.querySelector('.cart-upsell-modal__add');

    if (overlay) overlay.onclick = closeModal;
    if (closeBtn) closeBtn.onclick = closeModal;
    modal.onkeyup = function (e) { if (e.code === 'Escape') closeModal(); };

    if (addBtn) {
      addBtn.onclick = function () {
        if (!selectedVariant) return;
        addBtn.disabled = true;
        addBtn.classList.add('loading');
        addToCart(selectedVariant.id).then(function () {
          closeModal();
        }).finally(function () {
          addBtn.disabled = false;
          addBtn.classList.remove('loading');
        });
      };
    }
  }

  /* ── Bind upsell + buttons (called after each re-render) ── */
  function bindUpsellButtons() {
    document.querySelectorAll('.cart-upsell__add-btn').forEach(function (btn) {
      /* Clone to remove any stale listeners */
      const newBtn = btn.cloneNode(true);
      btn.parentNode.replaceChild(newBtn, btn);

      if (newBtn.classList.contains('cart-upsell__add-btn--variant')) {
        newBtn.addEventListener('click', function () { handleVariantAdd(newBtn); });
      } else {
        newBtn.addEventListener('click', function () { handleDirectAdd(newBtn); });
      }
    });
  }

  /* ── Initial bind ── */
  bindUpsellButtons();
  bindModalEvents();
})();
